import type { PaymentConfig, SavePayoutSettingsPayload } from 'src/interfaces/payment'
import { toNumber } from 'src/utils/paymentConfig'
import { toCentsInput, toRateInput } from '../paymentInputs'
import type { PayoutSettingsFormValues } from './PayoutSettingsForm.interface'

/**
 * Labels are Retool's, verbatim — including the two that drop "Transfer". Ordering here is the
 * form's ordering and drives the confirm modal's recap, so it stays in sync with
 * `PayoutSettingsFormContent`.
 */
export const PAYOUT_SETTINGS_LABELS: Record<keyof PayoutSettingsFormValues, string> = {
  payoutType: 'Payout Type',
  payoutTimeInHours: 'Payout Time in Hours',
  buyerFee: 'Buyer Fee (cents)',
  buyerRate: 'Buyer Rate (%)',
  loanTransferRate: 'Loan Transfer Rate (%)',
  loanTransferFee: 'Loan Fee (cents)',
  wireTransferRate: 'Wire Transfer Rate (%)',
  wireTransferFee: 'Wire Fee (cents)',
}

export function toFormValues(config: PaymentConfig): PayoutSettingsFormValues {
  return {
    payoutType: String(config.payoutType),
    payoutTimeInHours: toCentsInput(config.payoutTimeInHours),
    buyerFee: toCentsInput(config.buyerFee),
    buyerRate: toRateInput(config.buyerRate),
    loanTransferRate: toRateInput(config.loanTransferRate),
    loanTransferFee: toCentsInput(config.loanTransferFee),
    wireTransferRate: toRateInput(config.wireTransferRate),
    wireTransferFee: toCentsInput(config.wireTransferFee),
  }
}

/**
 * Exactly the eight scalars, plus `partnerId` for the URL substitution — the saga destructures
 * that out before building the body. `vendorFee`, `vendorRate` and `minEarning` are accepted by
 * the DTO and deliberately never sent: Retool never exposed them, and all three move real money.
 */
export function toSavePayload(
  partnerId: string,
  values: PayoutSettingsFormValues,
): SavePayoutSettingsPayload {
  return {
    partnerId,
    payoutType: values.payoutType,
    payoutTimeInHours: toNumber(values.payoutTimeInHours),
    buyerFee: toNumber(values.buyerFee),
    buyerRate: toNumber(values.buyerRate),
    loanTransferFee: toNumber(values.loanTransferFee),
    loanTransferRate: toNumber(values.loanTransferRate),
    wireTransferFee: toNumber(values.wireTransferFee),
    wireTransferRate: toNumber(values.wireTransferRate),
  }
}
